import { render, staticRenderFns } from "./ChoixCompetence.vue?vue&type=template&id=13a6978b&scoped=true"
import script from "./ChoixCompetence.vue?vue&type=script&lang=js"
export * from "./ChoixCompetence.vue?vue&type=script&lang=js"
import style0 from "./ChoixCompetence.vue?vue&type=style&index=0&id=13a6978b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a6978b",
  null
  
)

export default component.exports